const config = {
    apiKey: "AIzaSyCFFQBehrNpUziQGR3NypEJGQXpVijPP94",
    authDomain: "musclewiki-api.firebaseapp.com",
    databaseURL: "https://musclewiki-api.firebaseio.com",
    projectId: "musclewiki-api",
    storageBucket: "musclewiki-api.appspot.com",
    messagingSenderId: "867809465008",
    appId: "1:867809465008:web:54eaf5ee12af102d66a175",
    measurementId: "G-M7CXYX6MR0"
  }

export default config;